import React, { useEffect, useRef, useState } from 'react'
import QRCode from 'qrcode'
import { useLocale, useTranslation } from '@davi-ai/retorik-framework'

interface DownloadQRProps {
  url: string
}

const DownloadQR = ({ url }: DownloadQRProps): JSX.Element => {
  const translation = useTranslation()
  const locale = useLocale()

  const [qrCodeData, setQrCodeData] = useState<string | undefined>(undefined)
  const imageRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    setQrCodeDataAsync()
  }, [])

  const setQrCodeDataAsync = async (): Promise<void> => {
    const qrCodeString = await QRCode.toDataURL(url)
    setQrCodeData(qrCodeString)
  }

  return (
    <div style={{
          width: '100%',
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start"
        }}>
      {/* QR code for download */}
      <div
        style={{
          width: '100%',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "0.5rem",
          fontWeight: "bold",
          fontSize: "0.825rem",
          lineHeight: "1rem",
          paddingBottom : "5%"
        }}
      >
        <div style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "0.25rem",
          marginTop: "1rem"
          }}>
          <div style={{
            width: "fit-content"
          }}>
            Scannez pour accéder au site :
          </div>
        </div>

        {qrCodeData && (
          <div>
            <img
              ref={imageRef}
              src={qrCodeData}
              alt="QR Code"
              style={{
                height: "100%",
                maxHeight: "250px"
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default DownloadQR
